import React from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import {
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  educationInfo,
  bigProjects
} from "../../portfolio";

function Header() {
  return (
    <Headroom>
      <header className="header">
        <a href="#greeting" className="logo">
          <span className="logo-mark">SH</span>
          <span className="logo-name">Syafiqah Hisham</span>
        </a>

        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn" aria-label="Open navigation">
          <span className="navicon"></span>
        </label>

        <ul className="menu">
          {skillsSection.display && <li><a href="#skills">Skills</a></li>}
          {workExperiences.display && <li><a href="#experience">Experience</a></li>}
          {bigProjects.display && <li><a href="#projects">Projects</a></li>}
          {educationInfo.display && <li><a href="#education">Education</a></li>}
          {openSource.display && <li><a href="#opensource">Open Source</a></li>}
          {achievementSection.display && <li><a href="#achievements">Achievements</a></li>}
          {blogSection.display && <li><a href="#blogs">Blogs</a></li>}
          {talkSection.display && <li><a href="#talks">Talks</a></li>}
          <li><a href="#contact">Contact</a></li>
        </ul>
      </header>
    </Headroom>
  );
}

export default Header;
